// extracted by mini-css-extract-plugin
module.exports = {"hidden":"livestream-event-BlurFilterSvg__hidden--k6YJy"};